/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/hash.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Computes the hash of the input using various algorithms such as MD5, SHA, SHA-224, SHA-256, SHA-384, SHA-512.
 *
 * @example
 * FROM sample_data
 * | WHERE message != "Connection error"
 * | EVAL md5 = hash("md5", message), sha256 = hash("sha256", message)
 * | KEEP message, md5, sha256
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'hash',
  signatures: [
    {
      params: [
        {
          name: 'algorithm',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'input',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'algorithm',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'input',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'algorithm',
          type: 'text',
          optional: false,
        },
        {
          name: 'input',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'algorithm',
          type: 'text',
          optional: false,
        },
        {
          name: 'input',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
